import { Directive, Input, Output, ElementRef, EventEmitter, NgModule } from '@angular/core';
import * as Croppie from 'croppie';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Basic directive for creating Coppie instance on `<img>` tag.
 */
import * as ɵngcc0 from '@angular/core';
class CroppieDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.element = elementRef.nativeElement;
        this.update = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        (/** @type {?} */ (this.croppieOptions)).update = (data) => this.update.emit(data);
        this.croppie = new Croppie(this.element, this.croppieOptions);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (!!this.croppie) {
            this.croppie.destroy();
        }
    }
}
CroppieDirective.ɵfac = function CroppieDirective_Factory(t) { return new (t || CroppieDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CroppieDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CroppieDirective, selectors: [["img", "croppieOptions", ""]], inputs: { croppieOptions: "croppieOptions" }, outputs: { update: "update" }, exportAs: ["croppie"] });
/** @nocollapse */
CroppieDirective.ctorParameters = () => [
    { type: ElementRef, },
];
CroppieDirective.propDecorators = {
    "croppieOptions": [{ type: Input },],
    "update": [{ type: Output },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CroppieDirective, [{
        type: Directive,
        args: [{
                selector: 'img[croppieOptions]',
                exportAs: 'croppie'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { update: [{
            type: Output
        }], croppieOptions: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CroppieModule {
}
CroppieModule.ɵfac = function CroppieModule_Factory(t) { return new (t || CroppieModule)(); };
CroppieModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CroppieModule });
CroppieModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CroppieModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    CroppieDirective
                ],
                exports: [
                    CroppieDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CroppieModule, { declarations: function () { return [CroppieDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CroppieDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/*
 * Public API Surface of angular-croppie-module
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { CroppieDirective, CroppieModule };

